/**
 * Utility functions for navigation with referrer tracking
 */

/**
 * Adds referrer query parameter to a URL for back navigation
 * @param {string} targetUrl - The target URL to navigate to
 * @param {string} currentPath - The current path (pathname + search)
 * @returns {string} URL with referrer parameter
 */
export function addReferrerToUrl(targetUrl, currentPath) {
  const separator = targetUrl.includes('?') ? '&' : '?';
  return `${targetUrl}${separator}ref=${encodeURIComponent(currentPath)}`;
}

/**
 * Gets the referrer from URL query params or provides a fallback
 * @param {URLSearchParams} searchParams - URL search parameters
 * @param {string} fallbackPath - Fallback path if no referrer found
 * @returns {string} The referrer path or fallback
 */
export function getReferrerFromUrl(searchParams, fallbackPath) {
  const referrer = searchParams.get('ref');
  return referrer || fallbackPath;
}

/**
 * Checks if the current page was opened in a new window/tab
 * @returns {boolean} True if opened in new window
 */
export function isOpenedInNewWindow() {
  return window.opener !== null;
}

/**
 * Handles back navigation with referrer support
 * @param {Object} history - React Router history object
 * @param {Object} location - React Router location object
 * @param {string} defaultFallback - Default fallback path
 */
export function handleBackNavigation(history, location, defaultFallback) {
  const searchParams = new URLSearchParams(location.search);
  const referrer = searchParams.get('ref');

  if (referrer) {
    // If we have a referrer in URL, navigate to it
    history.push(referrer);
  } else if (window.history.length > 1 && document.referrer && !window.opener) {
    // If there's history and page wasn't opened in new window, go back
    history.goBack();
  } else {
    // Fallback to default
    history.push(defaultFallback);
  }
}
